import { FeatureAppNames } from './app-constants';
import { createMofaConfig } from './create-mofa-config';
import { ModelOverviewIntegratorOptions } from './create-options-from-query-params';
import { defaultAppConfig } from './default-app-config';
import { FORM_FEATURE_APP_CONTENT } from './feature-app-content/create-form-content';
import { createFormsAppConfig } from './feature-app-configs/create-forms-app-config';

const getCreateFunctionInstance = (featureAppName: string | undefined) => {
  switch (featureAppName) {
    case FeatureAppNames.FORMS as string:
      return createFormsAppConfig;
    case FeatureAppNames.DEFAULT as string:
      return defaultAppConfig.createFunctionInstance;
    default:
      return createMofaConfig;
  }
};

export const getConfigsFeatureApp = ({
  featureAppName,
  ...props
}: ModelOverviewIntegratorOptions) => {
  const createFunctionInstance = getCreateFunctionInstance(featureAppName);
  return createFunctionInstance(props);
};

export const contentFeatureAppMap = {
  [FeatureAppNames.FORMS]: FORM_FEATURE_APP_CONTENT,
  [FeatureAppNames.DEFAULT]: defaultAppConfig.appContent,
};
